var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 3,
    fill: "#00A35A",
    stroke: "#00A35A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0693 7C16.7572 7 16.4448 7.11874 16.2079 7.35696L10.9768 12.6127L8.79226 10.4178C8.55516 10.1796 8.24301 10.0608 7.93086 10.0608C7.6187 10.0608 7.3063 10.1796 7.0692 10.4178L6.35547 11.1351C5.88151 11.6111 5.88151 12.3901 6.35547 12.8661L7.67889 14.195C8.1526 14.671 8.92824 15.45 9.40219 15.9259L10.1157 16.643C10.3528 16.881 10.6652 17 10.9773 17C11.2895 17 11.6019 16.881 11.8387 16.643L18.6447 9.80524C19.1184 9.32929 19.1184 8.55025 18.6447 8.07431L17.9307 7.35696C17.6936 7.11899 17.3815 7 17.0693 7Z",
    fill: "#FAF7F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelected);
export default __webpack_public_path__ + "static/media/checkbox-selected.01d8370bdd3b79637e8ccb47af8428b1.svg";
export { ForwardRef as ReactComponent };